import { createExportWorker } from './createExportWorker';

// resolveWorker and terminateExportWorker share the cached worker instance, so they must live in one module.
let cachedWorker: Worker | null = null;
let workerConstructionFailed = false;

export const resolveWorker = (): Worker | null => {
  if (cachedWorker) {
    return cachedWorker;
  }

  if (workerConstructionFailed || typeof Worker === 'undefined') {
    return null;
  }

  const worker = createExportWorker();
  if (!worker) {
    workerConstructionFailed = true;
    return null;
  }
  cachedWorker = worker;
  return cachedWorker;
};

export const terminateExportWorker = (): void => {
  if (cachedWorker) {
    cachedWorker.terminate();
    cachedWorker = null;
  }
};
